(() => {
  if (window.KindredCoreGallery) return;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const refresh = () => {
    document.querySelectorAll('model-viewer[data-kindred-core-gallery]').forEach(model => {
      model.toggleAttribute('auto-rotate', !motion.matches);
    });
  };
  window.KindredCoreGallery = { refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
  document.addEventListener('shopify:section:load', refresh);
  motion.addEventListener('change', refresh);
})();
